import { useCallback } from "react";
import { MechanicsConfiguration } from "../models/mechanicsConfiguration.ts";
import { Signal } from "../models/signal.ts";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";

export const useTestpointSignals = () => {
  const { handle } = useMessageHandler();

  const getTestpointSignals = useCallback(async (
    payload: MechanicsConfiguration
  ): Promise<Signal[] | null> => {
    return await handle(async () => {
      const response = await apiJson.post("/electronics/testpoint_signals", payload);
      return response.data as Signal[];
    }).catch(() => null);
  }, [handle]);

  return { getTestpointSignals };
};
